import pathfinder from '@fiverr-private/pathfinder';

export const buildBiEventData = (biData) => {
    const { userId, sellerId, activeGigsCount } = biData;

    return ({
        group: 'seller_page',
        user: {
            id: userId
        },
        seller: {
            id: sellerId,
            active_gigs_count: activeGigsCount
        }
    });
};

export const buildSellerCardData = ({
    requestContext,
    currentUser,
    userData,
    currency,
    abTests,
    gigs,
    isViewerStudioLead,
    isTouch,
    collectProps = {}
}) => {
    const { page_ctx_id: pageCtxId } = requestContext;
    const { user, seller_card } = userData;
    const { response_time } = seller_card.user;

    const userId = currentUser && currentUser.id;
    const sellerId = seller_card.user.id;
    const activeGigsCount = gigs.gigs.length;
    const biData = {
        userId,
        sellerId,
        activeGigsCount
    };

    const responseTime = response_time ? response_time : null;
    const isLoggedIn = !!(currentUser && currentUser.id);

    seller_card.user.response_time = responseTime;
    seller_card.user.contact_path = pathfinder('conversation', { id: user.username });
    seller_card.user.has_live_gigs = !!activeGigsCount;
    seller_card.user.rating = seller_card.user.rating || 0;
    seller_card.user.status = user.status;

    seller_card.shouldShowReportUser = true;
    seller_card.allowEditing = false;
    seller_card.viewingAsBuyer = false;
    seller_card.isLoggedIn = isLoggedIn;
    seller_card.pageCtxId = pageCtxId;
    seller_card.currency = currency;
    seller_card.abTests = abTests;
    seller_card.isViewerStudioLead = isViewerStudioLead;

    // condition in the package - showCustomOrder && user.has_live_gigs && user.custom_orders_allowed && !allowEditing;
    // using this line as a hack not to display this button when user is guest
    seller_card.showCustomOrder = isLoggedIn;

    seller_card.biEventData = buildBiEventData(biData);
    seller_card.collectProps = {
        ...collectProps,
        sourceInfo: {
            name: 'user_page',
            userId,
            isTouch
        }
    };

    return {
        ...seller_card
    };
};

export const projectsShown = (projectList) => Math.min(projectList.length, 5);
export const buildPortfolioData = (portfolioData, seller) => {
    const { id, is_pro, username, achievement, profile_photo } = seller;
    const origin = 'seller_page';
    const link = pathfinder('user_portfolio_index', { user_id: username }, { query: { origin } });

    return {
        projectList: portfolioData?.portfolio_projects || [],
        totalProjects: portfolioData?.projects_count || 0,
        link,
        seller: {
            id,
            username,
            achievement,
            is_pro,
            has_profile_photo: !!profile_photo,
            profile_photo
        },
        origin
    };
};

export const buildFiverrLearnData = (fiverrLearnCourses) =>
    fiverrLearnCourses.map((course) => ({
        ...course,
        status_updated_at: new Date(course.status_updated_at).getTime()
    }));

export const buildProSubCategories = (pro_badge = {}, locale) => {
    const proSubCategories = pro_badge?.pro_sub_categories;

    if (!proSubCategories) { return []; }

    return proSubCategories.map((subCat) =>
        ({ id: subCat, name: i18n.t(`${locale}.sub_categories.sub_category_${subCat}.name`) })
    );
};
